// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"dee815a4","350":"e59c047e","382":"35eb4c88","701":"e67505be"}[chunkId] + ".chunk.js";
};